import { UserIsNotAuthenticated } from '@utils/router';

// redirect to /dashboard if user is already authed
export default UserIsNotAuthenticated;
